module.exports = __webpack_public_path__ + "static/img/diguang.5c936003.png";